import styles from "./subHeader.module.scss";
import { useMemo } from "react";
import { getServer } from "../../../utils/testCaseUtils";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useGetAllPrioritiesQuery } from "../../../api/priorityService";
import { useTranslation } from "react-i18next";
import { findProjectSettings } from "../../../store/selectors";

export const SubHeader = () => {
  const { t } = useTranslation();

  const selectedEnvironment = useSelector((state: RootState) => findProjectSettings(state).selectedEnvironment);
  const selectedTestCase = useSelector((state: RootState) => state.testCaseTemplateSlice.selectedTestCase);
  const selectedTestCaseTemplate = useSelector((state: RootState) => state.testCaseTemplateSlice.selectedTestCaseTemplate);

  const { data: priorities } = useGetAllPrioritiesQuery("");

  const getUrl: string = useMemo(() => {
    const server = getServer(selectedTestCaseTemplate, selectedEnvironment);

    if (!!server) {
      return `${server.url || ""}${selectedTestCase.endpoint}`
    } else {
      return selectedTestCase.endpoint || "";
    }
  }, [selectedTestCase, selectedTestCaseTemplate, selectedEnvironment]);

  const getPriority: string = useMemo(() => {
    const priority = priorities?.find(item => item.id === selectedTestCaseTemplate.priorityId);
    if (!!priority) {
      return `${t("testCaseTemplate.priority")} - ${priority.name}`;
    } else {
      return "";
    }
  }, [priorities, selectedTestCaseTemplate, t]);

  return (
    <div className={styles.container}>
      <span title={getUrl}>{getUrl}</span>
      <span title={getPriority}>{getPriority}</span>
    </div>
  );
}